import React from "react";

const NewAssessmentOptionForm = ({ onSubmit, onCancel }) => {
	const nameRef = React.createRef();
	const valueRef = React.createRef();
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				const name = nameRef.current.value;
				const value = valueRef.current.value;
				onSubmit({ name, value });
				nameRef.current.value = "";
				valueRef.current.value = "";
			}}
		>
			<div class="form-group">
				<label htmlFor="nameInput">Name</label>
				<input
					type="text"
					className="form-control input-height"
					id="nameInput"
					required
					ref={nameRef}
					aria-describedby="Name"
					placeholder="Enter name"
				/>
				<small id="nameInput" class="form-text text-muted">
					This would be displayed to the user.
				</small>
			</div>
			<div class="form-group">
				<label htmlFor="valueInput">Value</label>
				<input
					type="number"
					min="0"
					required
					ref={valueRef}
					className="form-control input-height"
					id="valueInput"
					placeholder="Enter value"
					max="10"
				/>
			</div>

			<div className="text-center">
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
				>
					Cancel<i className="material-icons text-danger">cancel</i>
				</button>

				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success"
				>
					Submit <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};

export default NewAssessmentOptionForm;
